import { gql } from "@apollo/client";

export const INGRESAR_SOLICITUDES_PENDIENTES = gql`
    mutation IngresarSolicitudesPendientes {
        ingresarSolicitudes
    }
`;